// extracted by mini-css-extract-plugin
export default {"container":"ArrowToTop_container__7Ila2","arrowToTopIcon":"ArrowToTop_arrowToTopIcon__gWYp7"};